<template>
  <v-list-item id="catagory-list">
    <v-list-item-icon class="icon-container">
      <v-icon class="small-icon" v-text="this.category.icon"></v-icon>
    </v-list-item-icon>
    <v-list-item-content class="index-wrapper">
      <v-list-item-title class="catagory-header"
        ><a
          :href="this.category.url"
          class="blue--text"
          v-text="this.category.title"
        ></a
      ></v-list-item-title>
      <template v-if="this.expanded">
        <v-list-item-content
          class="nav-selection"
          v-for="article in this.articles"
          :key="article.key"
          ><v-btn
            plain
            :href="getAnchorUrl(article)"
            class="text-none nav-button grey--text ml-4"
            style="text"
            v-text="article.title"
          ></v-btn
        ></v-list-item-content>
      </template>
    </v-list-item-content>
  </v-list-item>
</template>
<script>
export default {
  props: {
    category: Object,
    expanded: Boolean,
    articles: Array
  },
  methods: {
    getAnchorUrl(article) {
      return this.category.url + '#' + article.slug;
    }
  }
};
</script>
<style scoped>
.index-wrapper {
  padding-top: 1.4rem;
}
.catagory-header {
  padding-bottom: 10px;
}
.nav-selection {
  border-left: 1px solid #c4c4c4;
  padding: 0;
  margin-bottom: 0 !important;
}
.nav-button {
  justify-content: flex-start;
  padding: 10px !important;
  white-space: break-spaces !important;
  height: unset !important;
}
.nav-button:hover {
  background-color: #f1f1f1;
  text-decoration: none;
}
.icon-container {
  margin-right: 15px !important;
  margin-top: 20px !important;
}
.small-icon {
  width: 30px;
  color: rgb(80, 120, 216, 0.85) !important;
}
@media (orientation: portrait) {
  #catagory-list {
    display: none;
  }
}
@media (orientation: landscape) {
  #app-bar {
    display: none;
  }
}
</style>
